module.exports = __webpack_public_path__ + "static/media/748MeldrumStNW_2018-06-18_123.41b122d7.jpg";